import FeaturesComponent from "views/admin/plans/FeaturesComponent";
import CalendarInput from "components/addForm/CalendarInput";


const Subscription = {
  features: (props) => <FeaturesComponent {...props} />,
  end_date: (props) => (
    <CalendarInput
      name="end_date"
      label="Subscription End Date"
      value={props.value}
      isRequired={true}
      error={props.error}
      {...props}
      disablePastDate={true}
    />
  ),
};

export default Subscription;
